import React, { useEffect, useState } from 'react';
import Blogcard from './Blogcard';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { Paragraph } from '../basic/title';
import { useDispatch, useSelector } from 'react-redux';
import { getBlog } from '../../../redux/slices/blog';

const PaginationBlog = () => {
    const dispatch = useDispatch();
    const { allblog, isLoading, error } = useSelector((state) => state.blog);

    const [currentPage, setCurrentPage] = useState(1);
    const blogsPerPage = 6;

    useEffect(() => {
        dispatch(getBlog());
    }, [dispatch]);

    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    const currentBlogs = allblog.slice(indexOfFirstBlog, indexOfLastBlog);
    const totalPages = Math.ceil(allblog.length / blogsPerPage);

    const paginate = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    // if (isLoading) return <p className="text-center">Loading...</p>;
    if (error) return <p className="text-center text-red-600">Error: {error}</p>;

    return (
        <>
            <Blogcard allblog={currentBlogs} />

            <div className="flex justify-center mt-8 w-full">
                <div className="flex items-center justify-center space-x-4">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-4 py-2 bg-[#072320] text-white rounded disabled:opacity-50"
                    >
                        <FaAngleLeft />
                    </button>

                    {pageNumbers.map((number) => (
                        <button
                            key={number}
                            onClick={() => paginate(number)}
                            className={`px-3 py-1 rounded ${
                                currentPage === number ? 'bg-[#072320]' : 'bg-[#00a762b5]'
                            } text-white font-medium`}
                        >
                            {number}
                        </button>
                    ))}

                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="px-4 py-2 bg-[#072320] text-white rounded disabled:opacity-50"
                    >
                        <FaAngleRight />
                    </button>
                </div>
            </div>
        </>
    );
};

export default PaginationBlog;
